export const hoverBg1 = '#E5EEFF';
